import { c as s } from "./classof-raw.js";
var e = "undefined" != typeof process && "process" == s(process);
export { e };